import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useMessagesCountStore } from '@lib/store';
import { PaletteUtils } from '@shared/utils';
import MessageIcon from '@assets/icons/messages/messageNav.svg';

export const MessagesMenuItem = () => {
  const messagesCountStore = useMessagesCountStore();

  const { t } = useTranslation();

  return (
    <div className='flex items-center'>
      {t('nav.menu.messages')}
      <span className='relative ml-[8px] top-[1px]'>
        <MessageIcon className='mb-1' />
        {!!messagesCountStore.data && (
          <span
            className={clsx(
              'text-inherit absolute -right-[8px] left-[8px] h-[16px] min-w-[16px] leading-[16px] rounded-[8px] text-[10px] center py-0 px-[4px]',
              PaletteUtils.isBordierPalette ? 'bg-[#dc291c] text-white' : 'bg-[#d44112] text-inherit ',
            )}
          >
            {messagesCountStore.data}
          </span>
        )}
      </span>
    </div>
  );
};
